import React from 'react';
export default function Avatar(props) {
  var className = props.className,
      style = props.style;
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    style: style,
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: "50",
    cy: "50",
    r: "50"
  })), /*#__PURE__*/React.createElement("g", {
    id: "app-import-export",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "avatar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(0.000000, 0.000527)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E2E6EB",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7762846,88.6304348 L66.7657444,88.6304348 C65.6901186,87.8162055 64.5638999,87.0920949 63.3776021,86.4386034 C63.3470356,86.4185771 63.316996,86.3985507 63.2769433,86.3885375 C57.6664032,83.2918314 53.8661397,77.3192358 53.8661397,70.4523057 L45.370224,70.411726 C45.370224,77.2992095 41.5393939,83.3018445 35.8787879,86.3880105 C35.8787879,86.3880105 35.8687747,86.3880105 35.8587615,86.3980237 C34.6619236,87.0515152 33.5162055,87.785639 32.4300395,88.5898551 C29.9389239,90.4439689 27.758965,92.6910393 25.981974,95.2396993 C22.7383902,99.8918289 76.7643507,100.980958 74.0696927,96.6065797 C72.1616005,93.5090743 69.6815545,90.8018499 66.7762846,88.6304348 Z",
    fill: "#ECC19C",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3183136,111.651779 L20.8368906,111.651779 C20.8368906,102.200395 25.3913043,93.8251647 32.4295125,88.586693 C33.5156785,87.7824769 34.6613966,87.0483531 35.8577075,86.3948617 C35.8682477,86.3848485 35.8782609,86.3848485 35.8782609,86.3848485 C36.8031621,85.8720685 37.6880105,85.2886693 38.5022398,84.6251647 C41.3175231,87.5110672 45.2490119,89.3007905 49.602635,89.3007905 C53.9462451,89.3007905 57.8677207,87.5110672 60.6824769,84.6351779 C61.486693,85.2986825 62.3620553,85.8820817 63.2764163,86.3848485 C63.316469,86.3948617 63.3470356,86.414888 63.3770751,86.4349144 C64.5633729,87.0884058 65.6895916,87.8125165 66.7652174,88.6267457 L66.7757576,88.6267457 C73.7839262,93.8652174 78.3183136,102.220422 78.3183136,111.651779 Z",
    fill: "currentColor",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M27.5188406,27.5743083 L27.5188406,50.1492754 C27.5188406,65.4198946 40.9243742,77.7988142 49.5783926,77.7988142 C58.231357,77.7988142 71.6379447,65.4198946 71.6379447,50.1492754 L71.6379447,27.5743083 L27.5188406,27.5743083 Z",
    id: "Path",
    fill: "#ECC19C",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0442688,23.4193676 C63.2363636,17.3993412 55.9378129,13.5505929 47.773913,13.5505929 C33.2700922,13.5505929 21.5235837,25.6570487 21.5235837,40.586693 C21.5235837,48.5108037 24.8263505,55.6359684 30.1001318,60.5772069 C28.741502,57.1674572 27.9826087,53.3455863 27.9826087,49.3097497 C27.9826087,42.8238472 29.9536232,36.8839262 33.2300395,32.3158103 C36.7061924,33.8610013 42.3399209,34.4201581 48.5191041,33.5679842 C54.6455863,32.7289855 59.8661397,30.7047431 62.8094862,28.2942029 C68.1770751,33.0351779 71.6664032,40.6799736 71.6664032,49.3097497 C71.6664032,53.731357 70.7604743,57.8868248 69.1357049,61.5358366 C74.3162055,59.3914361 78.1254282,51.7471673 78.1254282,42.6504611 C78.1254282,32.9150198 73.7570487,24.8844532 68.0442688,23.4193676 Z",
    id: "Path",
    fill: "#494846",
    fillRule: "nonzero"
  }))));
}
Avatar.defaultProps = {
  style: {},
  className: undefined
};